import { foreignKey, pgEnum, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

import { applications } from './applications';
import { jobs } from './jobs';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

/**
 * Tracks the status of each ATS push step (transcript, stage_move) per application.
 * One row per (applicationId, step). Steps are independent — a failed transcript
 * does not block stage_move. Rows are reset to 'pending' on manual retry, allowing
 * the worker to re-attempt only the failed steps while skipping completed ones.
 */

export const atsPushStepEnum = pgEnum('ats_push_step', ['transcript', 'stage_move']);
export const atsPushStatusEnum = pgEnum('ats_push_status', ['pending', 'completed', 'failed']);

export const atsPushInterviewResultSteps = pgTable(
  'ats_push_interview_result_steps',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    applicationId: uuid('application_id').notNull(),
    jobId: uuid('job_id')
      .notNull()
      .references(() => jobs.id),
    step: atsPushStepEnum('step').notNull(),
    status: atsPushStatusEnum('status').notNull().default('pending'),
    errorMessage: text('error_message'),
    completedAt: timestamp('completed_at'),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    foreignKey({
      columns: [t.applicationId],
      foreignColumns: [applications.id],
      name: 'ats_push_steps_application_id_fk'
    }),
    unique().on(t.applicationId, t.step),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
